module.exports = __webpack_public_path__ + "img/left-front.3a774765.png";